import { GET_LIVE_SESSIONS, GET_VENDOR_USERS } from "utils/graphql/services/live-classes/queries";
import * as Yup from "yup";

export type SessionAllocation = {
  vendorUserId: String;
  allocationStatus: String;
  userType: String;
  entityType: String;
  buffer_at: [Date | null, Date | null];
  actual_at: [Date | null, Date | null];
  created_at: [Date | null, Date | null];
  updated_at: [Date | null, Date | null];
};

export const sessionAllocationInitialValues: SessionAllocation = {
  vendorUserId: "",
  allocationStatus: "",
  userType: "",
  entityType: "",
  buffer_at: [null, null],
  actual_at: [null, null],
  created_at: [null, null],
  updated_at: [null, null],
};

export const sessionAllocationMandatoryFields = [];

export const sessionAllocationValidationSchema = Yup.object().shape({
  created_at: Yup.array()
    .of(Yup.date().nullable())
    .test("is-range-complete", "End date is required", (value) => {
      if (!value) return true;
      const [start, end] = value;
      if (start && !end) return false;
      return true;
    }),
  updated_at: Yup.array()
    .of(Yup.date().nullable())
    .test("is-range-complete", "End date is required", (value) => {
      if (!value) return true;
      const [start, end] = value;
      if (start && !end) return false;
      return true;
    }),
  buffer_at: Yup.array()
    .of(Yup.date().nullable())
    .test("is-range-complete", "End date is required", (value) => {
      if (!value) return true;
      const [start, end] = value;
      if (start && !end) return false;
      return true;
    }),
  actual_at: Yup.array()
    .of(Yup.date().nullable())
    .test("is-range-complete", "End date is required", (value) => {
      if (!value) return true;
      const [start, end] = value;
      if (start && !end) return false;
      return true;
    }),
});

export const sessionAllocationProperties = [
   {
    id: "userType",
    type: "normal-select",
    label: "User Type",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 3, lg: 3 },
    options: [
      { label: "Licensed", value: "Licensed" },
      { label: "Basic", value: "Basic" },
    ],
  },
  {
    id: "vendorUserId",
    type: "single-select-search",
    label: "Vendor User",
    // list: "vendor_user_by_type_allocated",
    keyValue: { label: "email", value: "id" },
    query: GET_VENDOR_USERS,
    gqlKey: "getVendorUsers",
    dataKey: "vendorUsers",
    dependentOn: ["userType"],
    strictDependency: true,
    searchFieldKey: "email",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    required: true,
  },
 
  // {
  //   id: "allocationStatus",
  //   type: "text",
  //   label: "Allocation Status",
  //   Placeholder: "Enter Allocation Status",
  //   className: "name-styles",
  //   breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
  //   required: false,
  // },
  {
    id: "allocationStatus",
    type: "normal-select",
    label: "Allocattion Status",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 3, lg: 3 },
    options: [
      { label: "Scheduled", value: "scheduled" },
      { label: "Completed", value: "completed" },
    ],
    hideNone: false,
  },
  // {
  //   id: "entityType",
  //   type: "text",
  //   label: "Entity Type",
  //   Placeholder: "Enter Entity Type",
  //   className: "name-styles",
  //   breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
  //   required: false,
  // },
   {
    id: "entityType",
    type: "normal-select",
    label: "Entity Type",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 3, lg: 3 },
    options: [
      { label: "liveclass.teachers", value: "liveclass.teachers" },
      { label: "liveclass.nlearn3_students", value: "liveclass.nlearn3_students" },
    ],
    hideNone: false,
  },
  {
    id: "buffer_at",
    type: "date-range-picker",
    label: "Buffer Between",
    Placeholder: "Select Created Date Range",
    className: "created-date-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "actual_at",
    type: "date-range-picker",
    label: "Actual Between",
    Placeholder: "Select Created Date Range",
    className: "created-date-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "created_at",
    type: "date-range-picker",
    label: "Created Between",
    Placeholder: "Select Created Date Range",
    className: "created-date-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "updated_at",
    type: "date-range-picker",
    label: "Updated Between",
    Placeholder: "Select Updated Date Range",
    className: "updated-date-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
];

export function hasAtLeastOneValue(obj, keys) {
  return keys.some((key) => {
    const value = obj[key];
    return (
      value !== "" &&
      value !== null &&
      value !== undefined &&
      !(Array.isArray(value) && value.length === 0) &&
      !(Array.isArray(value) && value.every(v => v === null))
    );
  });
}
